@if (isModal) {
  <div class="modal-header bolt-space-bottom-md">
    <div class="modal-header-title" id="accountRegModalHeader">
      Online account registration
    </div>
    <div class="bolt-body-copy-md">
      To manage policy and view documents online
    </div>
  </div>
}
@if (readonly) {
  <div class="bolt-container-fluid">
    <div class="bolt-row bolt-align-items-center">
      <div class="bolt-col">
        @if (hasUpdatedRegistrationForm) {
          <label for="readonlyLinkPreference" class="faux-bolt-label no-mb">
            Online registration preference
          </label>
        } @else {
          <nwx-message-bubble
            [borderless]="true"
            iconName="info-circle-filled"
            iconColor="theme-info"
            iconSize="sm"
            >
            <div class="bolt-body-copy-sm">
              {{ accountSetupDisclaimer }}
            </div>
          </nwx-message-bubble>
        }
      </div>
      <div class="bolt-col">
        @if (hasUpdatedRegistrationForm) {
          <div class="readonly" id="readonlyLinkPreference">
            {{ readableLinkPref }}
            @if (canEdit) {
              <bolt-icon
                name="pencil-filled"
                color="mediumBlue"
                (click)="exitReadonly()"
              ></bolt-icon>
            }
          </div>
        } @else {
          <bolt-button
            type="solid"
            size="sm"
            width="full"
            (click)="exitReadonly()"
            >Set up online account
          </bolt-button>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="bolt-container-fluid relative" [class.modal-body]="isModal">
    @if (showSpinner) {
      <nwx-passive-spinner></nwx-passive-spinner>
    }
    <div [class.spinner]="showSpinner">
      @if (isModal) {
        <div class="bolt-space-bottom-2xl">
          <nwx-message-bubble
            [borderless]="true"
            iconName="info-circle-filled"
            iconColor="theme-info"
            >{{ accountSetupDisclaimer }}
          </nwx-message-bubble>
        </div>
        <hr class="full-length" />
      }
      <form
        [formGroup]="form"
        [nwxExposeFormErrors]="form"
        formName="onlineAccountRegistration"
        >
        <div class="bolt-row bolt-space-bottom-sm">
          <div class="bolt-col">
            <label
              for="doesCustomerWantOnlineAccount"
              class="faux-bolt-label no-mb"
              >
              {{ setupAcctLabel }}
            </label>
          </div>
          <div class="bolt-col">
            <bolt-radio-group
              [arialabel]="setupAcctLabel"
              label=""
              formControlName="doesCustomerWantOnlineAccount"
              required
              horizontal
              (change)="exitReadonly()"
              id="doesCustomerWantOnlineAccount"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
        @if (wantsOnlineAccount) {
          <div class="bolt-row bolt-space-bottom-sm">
            <div class="bolt-col">
              <label for="doesCustomerWantOnlineAccount">
                <strong>{{ linkPrefLabel }}</strong>
              </label>
            </div>
            <div class="bolt-col">
              <bolt-radio-group
                [arialabel]="linkPrefLabel"
                label=""
                formControlName="registrationLinkCommunicationMethod"
                required
                horizontal
                id="registrationLinkCommunicationMethod"
                >
                <bolt-radio value="MobilePhone">Mobile</bolt-radio>
                <bolt-radio value="ElectronicAddress">Email</bolt-radio>
              </bolt-radio-group>
            </div>
          </div>
        }
        @if (linkPreference && wantsOnlineAccount) {
          <div class="bolt-row bolt-align-items-center bolt-space-bottom-sm">
            <div class="bolt-col">
              @if (linkPreference === 'MobilePhone') {
                <label
                  for="primaryNamedInsuredMobileNumber"
                  >
                  <strong>Mobile phone number</strong>
                </label>
              }
              @if (linkPreference === 'ElectronicAddress') {
                <label
                  for="primaryNamedInsuredEmail"
                  ><strong>Email address</strong>
                </label>
              }
            </div>
            <div class="bolt-col">
              @if (linkPreference === 'MobilePhone') {
                <bolt-textfield
                  arialabel="Mobile phone number"
                  formControlName="primaryNamedInsuredMobileNumber"
                  required
                  class="nwpii"
                  [nwxMask]="'phone'"
                  [attr.id]="'primaryNamedInsuredPhoneNumber'"
                ></bolt-textfield>
              }
              @if (linkPreference === 'ElectronicAddress') {
                @if (pniEmail) {
                  <div class="readonly">
                    {{ pniEmail }}
                  </div>
                } @else {
                  <bolt-textfield
                    formControlName="primaryNamedInsuredEmail"
                    required
                    class="nwpii"
                    arialabel="Email address"
                    [attr.id]="'primaryNamedInsuredEmail'"
                  ></bolt-textfield>
                }
              }
            </div>
          </div>
        }
        @if (linkPreference === 'MobilePhone' && wantsOnlineAccount) {
          <div
            class="bolt-row"
            >
            <div class="bolt-col">
              <bolt-checkbox
                required
                formControlName="hasConsentedToOneTimeRegistrationText"
                id="hasConsentedToOneTimeRegistrationText"
                >
                The customer consents to receive a one time link regarding online
                account registration.
              </bolt-checkbox>
            </div>
          </div>
        }
        @if (wantsOnlineAccount) {
          <div class="bolt-row">
            <div class="bolt-col">
              <hr class="margin-spacing" />
            </div>
          </div>
          <div class="bolt-row">
            <div class="bolt-col bolt-body-copy-sm bolt-space-bottom-sm">
              <strong>Tell the customer:</strong> "If they do not receive a
              link, they need to go to Nationwide.com to complete the
              registration."
            </div>
          </div>
        }
      </form>
    </div>
  </div>
}
@if (isModal) {
  <div class="modal-footer">
    <bolt-button-bar>
      <bolt-button
        slot="forward"
        type="solid"
        (click)="onSubmit()"
        id="confirmRegistration"
        >
        Confirm registration
      </bolt-button>
    </bolt-button-bar>
  </div>
}
